import { MDBBtn, MDBChip, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBTextArea, MDBSpinner, MDBIcon, MDBAlert } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { AddStreamApiApp, checkAppNameAvailabilityInfo, getDefualtCallBackURLSInfo, getDefualtStreamsApiPermissions } from '../../../apiclients/streamsapi_bridge';
import { Tooltip } from 'react-tooltip';
import { t } from 'i18next';
import { useNavigate } from 'react-router';

function CreateStreamsAPIApps(props) {
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setInternalError] = useState(false);
    const [availabilityMsg, setAvailabilityMsg] = useState("");
    const [callBackURLS, setCallBackURLS] = useState([]);
    const navigate = useNavigate()
    const [formFieldsError, setformFieldsError] = useState(false);

    const [permissionError, setPermissionError] = useState(false);
    const [permissionsArray, setPermissionsArray] = useState([]);     

   
      

    // Form setup
    const {
        formState: { isDirty, errors, dirtyFields },
        setValue,
        register,
        handleSubmit,
        reset,
        watch,
        trigger
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            applicationName: "",
            organizationName: "",
            organizationWebsite: "",
            description: "",
            app_permission: [],
            api_urls: { Inbound_SMS: callBackURLS.Inbound_SMS, CTC: callBackURLS.CTC, Inbound_FAX: callBackURLS.Inbound_FAX, Outbound_SMS: callBackURLS.Outbound_SMS }
        }
    });

    const removePermission = (permissionId) => {
        const permInfo = selectedPermissions.filter(p => p.app_permission_id !== permissionId)
        setSelectedPermissions(permInfo);
        setValue("app_permission", permInfo, { shouldDirty: true })
    };

    const togglePermission = (permissionId) => {
        const exists = selectedPermissions?.some(p => p.app_permission_id === permissionId);
        if (!exists) {
            setSelectedPermissions((prev) => [...prev, { app_permission_id: permissionId }]);
            let permissionInfo = [...selectedPermissions, { app_permission_id: permissionId }]
            setValue("app_permission", permissionInfo, { shouldDirty: true })
        } else {
            removePermission(permissionId)
        }
        console.log(dirtyFields)
        trigger("app_permission");
};

    // Format permissions for API request
    // const formatPermissionsForApi = () => {
    //     return selectedPermissions.map(permissionId => {
    //         const permission = availablePermissions.find(p => p.id === permissionId);
    //         return {
    //             app_permission_id: permissionId,
    //             ...(permission && { name: permission.value })
    //         };
    //     });
    // };

    // Frame API request parameters
    const frameApiParams = (formData) => {
        // const formattedPermissions ={};
        console.log("[saveApp] Description value:", JSON.stringify(formData));
        // console.log("[saveApp] Description from getValues():", currentFormValues.description);
        if (selectedPermissions.length == 0) {
            console.log("permissionError ");
            setPermissionError(true);
        }
        let sitename = JSON.parse(sessionStorage.getItem("admin_session")).sitename ?? "";
        return {
            appData: {
                appname: formData.applicationName?.trim(),
                org_name: formData.organizationName?.trim(),
                org_website: formData.organizationWebsite?.trim(),
                description: formData.description,
                app_permission: formData?.app_permission,
                ctcWebhookURL: formData.api_urls?.CTC,
                inboundSMSWebhookURL: formData.api_urls?.Inbound_SMS,
                inboundFAXWebhookURL: formData.api_urls?.Inbound_FAX,
                outboundSMSWebhookURL: formData.api_urls?.Outbound_SMS,
                sitename: sitename,
                status: 2,
                created_at: new Date().toISOString()
            }
        };
    };
    const handleWebhookChange = (key, value) => {
        console.log("handleWebhookChange :: ", key, value)
        setValue(`api_urls.${key}`, value, { shouldDirty: true })
    };
    const onFormError = (errors) => {
        console.log("Validation errors:", errors);
        if (errors?.app_permission || errors?.applicationName) {
            setformFieldsError(true);
            setTimeout(() => {
                setformFieldsError(false);
            }, 2000);
        }
    };
    if (errors?.app_permission || errors?.applicationName) {
        setTimeout(() => {
            const section = document.getElementById("ApplicationName");
            console.log("section", section);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    }


    // Main save function (final version merged)
    const saveApp = async (formData) => {
        try {
            console.log("[saveApp] Starting save process with form data:", JSON.stringify(formData));
            if (selectedPermissions.length === 0) {
                setPermissionError(true);
                return; // Stop save
            }
            setPermissionError(false);
            // setIsLoading(true);
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

            console.log("siteid :::" + siteid);
            // Frame params
            const validationErrors = validateForm(formData);

            const apiParams = frameApiParams(formData);
            console.log(apiParams)
            // API request
            const serverResponse = await AddStreamApiApp(siteid, apiParams);

            if (serverResponse.ok) {
                const responseData = await serverResponse.json();
                console.log("[saveApp] App created successfully:", JSON.stringify(responseData));
                props.setOpen(false);
                localStorage.setItem("s_message", `${apiParams.appData.appname} Streams API App created successfully!`)
                navigate("/streamsapisettings", {
                    state: { data: { id: responseData.app_id } },
                });

            } else {
                setInternalError(true);
                setTimeout(() => {
                    setInternalError(false)
                }, 1000)

            }
        } catch (error) {
            console.error("[saveApp] Error while saving app:", error);
            // alert("Error while saving app: " + error.message);
        } finally {
            // setIsLoading(false);
        }
    };
    const validateForm = (formData) => {

        if (!formData.applicationName?.trim()) {
            errors.push("Application name should not be empty");
        }
        return errors;
    };

    const handleModalClose = () => {
        props.setOpen(false);
        reset();
        setSelectedPermissions([]);
    };

    const checkAppNameAvailability = async (name) => {
        try {
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                appname: name
            }
            const res = await checkAppNameAvailabilityInfo(siteid, params);
            const response = await res.json()
            console.log(response)
            return response.appIsAvailable ?? false;
        } catch (error) {
            console.error("Error checking app name availability:", error);
            setAvailabilityMsg(" Error checking availability");
            return false; // in case of error, treat as not available
        }
    }
    const getDefualtCallBackURLS = async () => {
        try {
            console.log("getDefualtCallBackURLS :: ")
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            console.log("getDefualtCallBackURLS :: " + siteid);

            const serverResponse = await getDefualtCallBackURLSInfo(siteid);
            if (serverResponse.ok) {
                const responseData = await serverResponse.json();
                console.log("[saveApp] App created successfully:", JSON.stringify(responseData));
                setCallBackURLS(responseData?.webhook_urls);
            } else {
                setCallBackURLS([]);
            }
        } catch (error) {
            console.error("getDefualtCallBackURLS:", error);
        }

    }

    const getAppPermissions =async ()=>{
        try {
            console.log("getDefualtCallBackURLS :: ")
            const serverResponse = await getDefualtStreamsApiPermissions();
            if (serverResponse.ok) {
                const responseData = await serverResponse.json();
                console.log("[saveApp] App created successfully:", JSON.stringify(responseData));
                const PERMISSIONS_CONFIG = responseData.permissionArray.map((item) => {
                    // Generate a clean key name
                    const key = item.value.replace(" ", "_");
                  
                    // Default descriptions (can be customized per feature)
                    const defaultDescriptions = {
                      "read call recordings": "Access and download call recording files from your account.",
                      "read cdr": "View detailed call records and download associated call recording files.",
                      "read account info": "Access essential account details, including user and group information.",
                      "ctc": "Enable click-to-call functionality and receive call event notifications.",
                      "write call recordings": "Delete unwanted call recordings from your account.",
                      "outbound sms": "Easily send SMS messages to phone numbers directly from your account.",
                      "inbound sms": "Receive and process incoming SMS messages via webhook notifications.",
                      "outbound fax": "Easily send fax documents to recipients directly from your account.",
                      "inbound fax":"Receive and process incoming fax documents via webhook notifications."
                    };
                  
                    const webhookConfig = {
                        "inbound sms": { show: true, required: true },
                        "ctc": { show: true, required: true },
                        "inbound fax": { show: true, required: true },
                        "outbound sms": { show: true, required: false }, //  OPTIONAL
                    };

                    const config = webhookConfig[item.value.toLowerCase()] || {};

                  
                    return {
                        id: item.id,
                        key,
                        label: item.value,
                        desc: defaultDescriptions[item.value.toLowerCase()] || "No description available.",
                        ...(config.show ? { requiresWebhook: true } : {}),
                        ...(config.required !== undefined ? { webhookRequired: config.required } : {}),
                    };
                  });
                    const SORTED_PERMISSIONS = PERMISSIONS_CONFIG.sort((a, b) =>
                    a.label.localeCompare(b.label)
                );

                  setPermissionsArray(SORTED_PERMISSIONS)

                //   setPermissionsArray(PERMISSIONS_CONFIG)
                  
            } else {
                setPermissionsArray([]);
            }
        } catch (error) {
            console.error("getDefualtCallBackURLS:", error);
        }
    }

    useEffect(() => {
        console.log("usefect called ::::")
        getDefualtCallBackURLS();  // Fetch default callback URLs on component mount
        getAppPermissions();
    }, []);

    return (
        <>
            <MDBModal tabIndex="-1" open={props.open} onClose={handleModalClose} size="lg">
                <MDBModalDialog size='xl'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Create Streams API App</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={handleModalClose} disabled={isLoading}></MDBBtn>
                        </MDBModalHeader>

                        <MDBModalBody>
                            <form onSubmit={handleSubmit(saveApp)}>
                                {/* Application Name */}
                                <div className="mb-3">
                                    <strong>Application Name <span id = "ApplicationName" style={{ color: "red" }}>*</span></strong>
                                    <MDBInput 
                                        placeholder='Enter Application Name'
                                        {...register("applicationName", {
                                            required: "Application name should not be empty",
                                            minLength: { value: 3, message: "Application Name must be at least 3 characters" },
                                            validate: async (value) => {
                                                if (!value || value.length < 3) {
                                                    setAvailabilityMsg("");
                                                    return true;
                                                }
                                                const available = await checkAppNameAvailability(value);
                                                if (!available) {
                                                    return "This application name is already taken";
                                                }
                                                return true;
                                            }
                                        })}
                                        invalid={!!errors.applicationName}
                                    />
                                    {errors.applicationName && <div className="text-danger mt-1">
                                        {errors.applicationName.message}</div>}
                                    {!errors.applicationName && watch("applicationName")?.length >= 3 && (
                                        <div className="text-success mt-1">
                                            Application name is available
                                        </div>
                                    )}
                                </div>

                                {/* Organization Name */}
                                <div className="mb-3">
                                    <strong>Organization Name </strong>
                                    <MDBInput
                                        placeholder='Enter Organization Name'
                                        {...register("organizationName",
                                            // { required: "Organization Name is required" }
                                        )}
                                        invalid={!!errors.organizationName}
                                    />
                                    {errors.organizationName && <div className="text-danger small mt-1">
                                        {errors.organizationName.message}</div>}
                                </div>

                                {/* Organization Website */}
                                <div className="mb-3">
                                    <strong>Organization Website </strong>
                                    <MDBInput
                                        placeholder='Enter Organization Website'
                                        {...register("organizationWebsite", {
                                            // required: "Organization Website is required",
                                            // pattern: { value: /^https?:\/\/.+\..+/, message: "Please enter a valid website URL" }
                                        })}
                                        invalid={!!errors.organizationWebsite}
                                    />
                                    {errors.organizationWebsite && <div className="text-danger small mt-1">
                                        {errors.organizationWebsite.message}</div>}
                                </div>
                                <div className="form-section">
                                    <div className="section-title d-flex align-items-center">Permissions Configuration <span style={{ color: "red" }}>*</span> 
                                    </div>
                                    <p className="section-description">
                                        Select the permissions your application needs. Some permissions require webhook endpoints.
                                    </p>
                                    <div className='mb-3'>
                                    <div className="info-alert m-0">
                                        <span className="info-icon">ℹ️</span>
                                        <div className="info-content">
                                            <strong>Webhook Required:</strong> Inbound SMS, Inbound FAX and CTC permissions require webhook URLs to
                                            receive real-time events. You'll need to configure these endpoints below.
                                        </div>
                                      
                                    </div>
                                            {errors.app_permission && (
                                                <div className="text-danger mt-2">
                                                    {errors.app_permission.message}
                                                </div>
                                            )}
                                    </div>

                                    
                                   

                                    <div className="permissions-list">
                                        {permissionsArray.map((perm) => (
                                            <div key={perm.id} className="permission-item">
                                                <label className="permission-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        value={perm.key}
                                                        // checked={props.selectedPermissions?.some(p => p.app_permission_id === perm.id)}
                                                        onChange={() => togglePermission(perm.id)}
                                                    />
                                                    <div className="permission-content">
                                                        <div className="permission-header">
                                                            <span className="permission-label">{perm.label}</span>
                                                            {perm.requiresWebhook &&
                                                                perm.label.toLowerCase() !== "outbound sms" && (
                                                                    <span className="webhook-badge">Webhook Required</span>
                                                                )}
                                                        </div>
                                                        <div className="permission-description">{perm.desc}</div>
                                                    </div>
                                                </label>

                                                {/* Show webhook config if required & selected */}
                                                {perm.requiresWebhook && selectedPermissions?.some(p => p.app_permission_id === perm.id) && (
                                                    <div className="webhook-config">
                                                        <div className="webhook-field">
                                                            <label className="webhook-label">
                                                                {perm.label} Webhook URL
                                                                {perm.webhookRequired ? (
                                                                    <span className="required-asterisk">*</span>
                                                                ) : (
                                                                    <span className="text-muted ms-1">(Optional)</span>
                                                                )}
                                                            </label>

                                                            <div className="webhook-input-group">
                                                                <input

                                                                    type="url"
                                                                    className="webhook-input pe-2"
                                                                    placeholder={`https://your-domain.com/webhooks/${perm.key}`}
                                                                    defaultValue={callBackURLS[perm.key]}
                                                                    {
                                                                    ...register(`api_urls.${perm.key}`, {
                                                                        required: perm.webhookRequired
                                                                            ? `${perm.label} WebHook URL is required`
                                                                            : false,
                                                                        pattern: {
                                                                            value: /^(((https):\/\/)(([a-zA-Z0-9-_\.]+[\.][A-Za-z0-9:]+))(\/[a-zA-Z0-9-_\.]*)*)(([\?]?)([a-zA-Z0-9-_\.&=@%\(\)]+)?)$/,
                                                                            message: "Please Enter valid WebHook URL"
                                                                        },
                                                                        onChange: (e) => handleWebhookChange(perm.key, e.target.value),
                                                                    })
                                                                    }
                                                                />
                                                                {errors.api_urls?.[perm.key] && (
                                                                    <div className="text-danger small mt-1">
                                                                        {errors.api_urls?.[perm.key].message}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="webhook-help">
                                                                This endpoint will receive POST requests for {perm.label} events.
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                    <input
                                        type="hidden"
                                        {...register("app_permission", {
                                            validate: (val) =>
                                                (val && val.length > 0) || "Select at least one permission"
                                        })}
                                    />

                                </div>
                                {/* Description */}
                                <div className="my-3">
                                    <strong>Description </strong>
                                    <MDBTextArea
                                        rows={4}
                                        placeholder="Describe your application and its purpose"
                                        onChange={(e) => {
                                            setValue("description", (e.target.value), {
                                                shouldDirty: true,
                                            });
                                        }}
                                        invalid={!!errors.description}
                                    />
                                    {errors.description && <div className="text-danger small mt-1">
                                        {errors.description.message}</div>}
                                </div>
                            </form>
                            {
                                isLoading && (
                                    <div>
                                        <div className="loadingclass-popup"></div>
                                        <div className="popup-bg-loader loader_align">
                                            <MDBBtn disabled>
                                                <MDBSpinner
                                                    size="sm"
                                                    role="status"
                                                    tag="span"
                                                    className="me-2"
                                                />
                                                Loading...
                                            </MDBBtn>
                                        </div>
                                    </div>
                                )
                            }
                            {isError && (
                                <MDBAlert
                                    open
                                    className="alert-center"
                                    color="danger"
                                    autohide
                                    position="bottom-right"
                                    delay={100000}
                                >
                                    {t("Provisioning_Error_Aleart")}
                                </MDBAlert>
                            )}
                            {formFieldsError && (<MDBAlert
                                color="danger"
                                className="alert-center"
                                autohide
                                position="bottom-right"
                                open
                                delay={100000}
                            >Please check error messages and enter valid data.</MDBAlert>)}

                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={handleModalClose} disabled={isLoading}>Cancel</MDBBtn>
                            <MDBBtn color="primary" onClick={handleSubmit(saveApp,onFormError)}>Save</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>


            <Tooltip anchorSelect=".inboundSmsinfo" place="top" className="exampleTooltipLight">
                Enter a valid WebHook URL <br /> to receive incoming SMS messages <br /> to your application.
            </Tooltip>

            <Tooltip anchorSelect=".ctcinfo" place="top" className="exampleTooltipLight">
                Enter a valid WebHook URL to <br /> receive CTC request to <br /> your application.
            </Tooltip>
        </>
    );
}

export default CreateStreamsAPIApps;
